import http from '@http';
import { IChartData, IConfig, IFilter, ITableHeader, ITableItem, VIEW_TYPES } from '../types';

export class RoomsFilter implements IFilter {
    createConfig(): IConfig {
        return {
            name: 'Rooms',
            getTasks: async (rootState, rootGetters, params) => {
                const { data } = await http.get(`/api/reports/companies/${rootGetters.selectedCompanyId}/rooms`, {
                    params,
                });
                return data.map(this.taskFromJSON);
            },
            getChartData: async (rootState, rootGetters, params) => {
                const { data } = await http.get(
                    `/api/reports/companies/${rootGetters.selectedCompanyId}/plots/rooms/binary-tasks`,
                    { params }
                );

                return this.createChartsData(data);
            },
            getTableData: async (rootState, rootGetters, params) => {
                if (rootGetters['reports/currentState'].tasks.length) {
                    const [room] = rootGetters['reports/currentState'].tasks;
                    const { data } = await http.get(
                        `/api/reports/companies/${rootGetters.selectedCompanyId}/rooms/${room}/binary-tasks`,
                        { params }
                    );

                    return {
                        originData: data,
                        headers: this.createTableHeaders(rootGetters['reports/tasksOptions']),
                        data: this.createTableItems(data),
                    };
                }

                return null;
            },
            isSingleTaskSelectable: true,
            applicable: [],
            groupBy: [],
            viewTypes: [
                {
                    key: VIEW_TYPES.table,
                    name: 'Table view',
                },
                {
                    key: VIEW_TYPES.matrix,
                    name: 'Matrix view',
                },
            ],
            state: {
                currentView: VIEW_TYPES.matrix,
            },
        };
    }
    taskFromJSON(i) {
        return { id: i.room_id, name: i.name };
    }
    createTableHeaders(json: any): ITableHeader[] {
        return [];
    }
    createTableItems(json: any): ITableItem[] {
        return [];
    }
    createChartsData(json: any): IChartData[] {
        const data: any = Array.isArray(json) ? json : Object.keys(json).map((key) => json[key]);

        return data.map((i) => {
            const dataValue = i.data || i.traces;
            const layoutValue = i.layout || { title: i.title };

            return {
                data: dataValue,
                layout: layoutValue,
            };
        });
    }
    createRequestProps() {
        return {};
    }
}
